<!-- 总评center地图 -->
<style lang="stylus" scoped>
.map {
  width: 655px;
  height: 630px;
  margin: 0 auto;

  .satelliteMap {
    width: 100%;
    height: 100%;
    background-color: transparent !important;
  }
}
</style>
<style>
.amap-logo,
.amap-copyright {
  display: none !important;
}
</style>

<template>
  <div class="map">
    <div :id="id" class="satelliteMap"></div>
  </div>
</template>

<script>
import monitorIcon from '../../../../../static/img/industryInformation/monitor-icon.png'
import echarts from 'echarts'
import axios from 'axios'
import Vue from 'vue'
import VueAMap, { lazyAMapApiLoaderInstance } from 'src/amap.js';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
  plugin: ['AMap.DistrictSearch', 'AMap.Polygon'],
  uiVersion: '1.0.11',
  v: '1.4.15'
});
const opts = { subdistrict: 0, extensions: 'all' };
const colors = [
  "#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00",
  "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707",
  "#651067", "#329262", "#5574a6", "#3b3eac"
];
const markers = [
  { point: [106.592535429688, 23.4990334296876], content: '文本内容1文本内容1文本内容1', title: '标题1' },
  { point: [107.003172636719, 23.6282497382813], content: '文本内容2文本内容2文本内容2', title: '标题2' },
  { point: [107.03298953125, 23.875044171875], content: '文本内容3文本内容3文本内容3', title: '标题3' }
];
const geoCoordMap = {
  '右江区': [106.6189648699, 23.9011510432],
  '靖西市': [106.4176986464, 23.1340325224],
  '田阳县': [106.9156629745, 23.7356699750],
  '田东县': [107.1260862186, 23.5972525589],
  '平果县': [107.5898772387, 23.3293469441],
  '德保县': [106.6154958178, 23.3234056946],
  '那坡县': [105.8335036062, 23.3871180613],
  '凌云县': [106.5615967920, 24.3475183354],
  '乐业县': [106.5616359496, 24.7858389344],
  '田林县': [106.2285227061, 24.2943864015],
  '西林县': [105.0938229983, 24.4895710923],
  '隆林县': [105.3438807417, 24.7706591482]
}
export default {
  data() {
    return {
      myChart: {},
      id: `map-${Date.now()}`,
      map: null,
      district: null,
      districtExplorer: null,
      cityAdcode: '',
      cityName: '百色市',
      ifSatellite: true
    }
  },
  components: {
  },
  mounted: function () {
    this.initMap()
    // setTimeout(this.initMap, 500);
  },
  methods: {
    initMap() {
      lazyAMapApiLoaderInstance.load().then(async () => {
        this.district = new AMap.DistrictSearch(opts);
        await this.renderCity();
        // this.renderMarkers();
        await this.createDistrictExplorer();
        this.renderDistrict();
        await this.createText()
      });
    },
    renderCity() {
      return new Promise(resolve => {
        this.district.search(this.cityName, (status, result) => {
          this.cityAdcode = result.districtList[0].adcode;
          const bounds = result.districtList[0].boundaries;
          const mask = [];
          for (let i = 0; i < bounds.length; i += 1) {
            mask.push([bounds[i]])
          }
          this.map = new AMap.Map(this.id, {
            mask,
            viewMode: '3D',
            zoom: 8,
            cursor: 'pointer',
            center: new AMap.LngLat(106.2285227061, 24.0943864015),
            layers: [new AMap.TileLayer.Satellite()]
          });
          resolve();
        });
      });
    },
    handleMarkerClick(marker) {
      return () => {
        const extData = marker.getExtData();
        const infoWindow = new AMap.InfoWindow({
          content: '<div>title:' + extData.title + '<br/>content:' + extData.content + '</div>',
          offset: new AMap.Pixel(0, -35)
        });
        infoWindow.open(this.map, marker.getPosition());
      }
    },
    renderMarkers() {
      for (let i in markers) {
        const icon = new AMap.Icon({
          size: new AMap.Size(30, 30),
          imageSize: new AMap.Size(30, 30),
          image: monitorIcon
        });
        const marker = new AMap.Marker({
          position: new AMap.LngLat(markers[i].point[0], markers[i].point[1]),
          cursor: 'pointer',
          icon: icon,
          extData: markers[i]
        });
        marker.on('click', this.handleMarkerClick(marker));
        this.map.add(marker);
      }
    },
    createDistrictExplorer() {
      return new Promise(resolve => {
        AMapUI.load(['ui/geo/DistrictExplorer', 'lib/$'], (DistrictExplorer, $) => {
          this.districtExplorer = new DistrictExplorer({ eventSupport: true, map: this.map });
          resolve();
        });
      });
    },
    renderDistrict() {
      const that = this;
      return new Promise(resolve => {
        this.districtExplorer.loadAreaNode(this.cityAdcode, (error, areaNode) => {
          console.log(error)
          this.districtExplorer.renderSubFeatures(areaNode, (feature, i) => {
            const fillColor = colors[i % colors.length]; // 填充色
            const strokeColor = colors[colors.length - 1 - i % colors.length]; // 边框色
            resolve();
            return {
              cursor: 'default',
              bubble: true,
              strokeColor, // 线颜色
              strokeOpacity: 1, // 线透明度
              strokeWeight: 1, // 线宽
              fillColor, // 填充色
              fillOpacity: 0.1 // 填充透明度
            };
          });
          this.districtExplorer.on('featureClick', function (e, feature) {
            that.$router.push(`/secondMap?areaName=${feature.properties.name}`);
          });
        });
      })
    },
    createText() {
      // 创建纯文本标记
      for (var i in geoCoordMap) {
        var text = new AMap.Text({
          text: i,
          anchor: 'center', // 设置文本标记锚点
          draggable: true,
          cursor: 'pointer',
          angle: 10,
          style: {
            'padding': '10px 5px',
            'background-color': 'transparent',
            'width': '80px',
            'border': 'none',
            'text-align': 'center',
            'font-size': '16px',
            'color': '#fff'
          },
          position: geoCoordMap[i]
        });
        text.setMap(this.map);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?07b52a9e